export default __webpack_public_path__ + "static/media/24H_Lake.96e637e2.png";